import { DateTime } from 'luxon';

export function getTimeZone(): string {
  return DateTime.local().zoneName;
}
